import React from "react";
import { useTranslation } from "react-i18next";
import { Event, EventGuestStatistic } from "../../../models/Event";
import { OutputSettings, StepValidation } from "./useCreateWizard";
import { NamingCard, DeletionSettingsCard, GuestsCard, StorageCard } from "./cards";

interface StepOutputSettingsProps {
    outputSettings: OutputSettings;
    onOutputSettingsChange: (settings: Partial<OutputSettings>) => void;
    selectedEvent: Event | null;
    eventGuestStatistic: EventGuestStatistic | null;
    validation?: StepValidation;
    isTrialMode: boolean;
}

const StepOutputSettings: React.FC<StepOutputSettingsProps> = ({
    outputSettings,
    onOutputSettingsChange,
    selectedEvent,
    eventGuestStatistic,
    validation,
    isTrialMode,
}) => {
    const { t } = useTranslation("wizard");

    return (
        <div className="step-output-settings">
            <h3 className="mb-4">{t("outputSettings.stepTitle")}</h3>
            <p className="text-muted small mb-4">{t("outputSettings.description")}</p>

            <NamingCard
                outputSettings={outputSettings}
                onOutputSettingsChange={onOutputSettingsChange}
                selectedEvent={selectedEvent}
                eventGuestStatistic={eventGuestStatistic}
                validation={validation?.fieldValidations?.documentName}
            />
            <GuestsCard
                outputSettings={outputSettings}
                onOutputSettingsChange={onOutputSettingsChange}
                selectedEvent={selectedEvent}
                eventGuestStatistic={eventGuestStatistic}
            />
            <StorageCard
                outputSettings={outputSettings}
                onOutputSettingsChange={onOutputSettingsChange}
                selectedEvent={selectedEvent}
                eventGuestStatistic={eventGuestStatistic}
                validation={validation?.fieldValidations?.customFieldDefinitionId}
            />
            <DeletionSettingsCard
                outputSettings={outputSettings}
                onOutputSettingsChange={onOutputSettingsChange}
                selectedEvent={selectedEvent}
                eventGuestStatistic={eventGuestStatistic}
                isTrialMode={isTrialMode}
            />
        </div>
    );
};

export default StepOutputSettings;
